angular.module('gym.contacts').factory('NonAttendingContacts', ["Restangular", "$rootScope", function(Restangular, $rootScope) {
  var params;
  params = $rootScope.toParams;
  return Restangular.one('gyms', params.gymId).all('non_attending_contacts');
}]);
